import { ref, computed } from 'vue'

const createEmptyDecisionReason = () => ({
    decision_type: null,
    decision_text: null
})

export function useDecisionReasons(initialReasons = [], initialDecisionInfos = []) {
    const decisionReasons = ref(initialReasons.map(reason => ({
        ...createEmptyDecisionReason(),
        ...reason
    })))

    const decisionInfos = ref(initialDecisionInfos)

    const addDecisionReason = () => {
        decisionReasons.value.push(createEmptyDecisionReason())
    }

    const deleteDecisionReason = (index) => {
        decisionReasons.value.splice(index, 1)
    }

    const updateDecisionReason = (index, field, value) => {
        if (index >= 0 && index < decisionReasons.value.length) {
            decisionReasons.value[index] = {
                ...decisionReasons.value[index],
                [field]: value
            }
        }
    }

    const isValid = computed(() => {
        return decisionReasons.value.every(reason =>
            reason.decision_type !== null &&
            reason.decision_text &&
            reason.decision_text.trim() !== ''
        )
    })

    return {
        decisionReasons,
        decisionInfos,
        addDecisionReason,
        deleteDecisionReason,
        updateDecisionReason,
        isValid
    }
}
